import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import "@/assets/tailwind.css";
import i18n from './i18n'

import LoadingOverlay from "@/components/LoadingOverlay.vue";


Vue.config.productionTip = false

import Card from "@/components/graphics/Card.vue";
import Topbar from "@/components/graphics/Topbar.vue";
import Slider from "@/components/graphics/Slider.vue";
import Dropdown from "@/components/graphics/Dropdown.vue";
import { getIconHtml, icons } from './services/icons'
import AsyncComputed from 'vue-async-computed'

Vue.component('Card', Card)
Vue.component('Topbar', Topbar)
Vue.component('Dropdown', Dropdown)
Vue.component('Slider', Slider)
Vue.use(AsyncComputed)

Vue.directive('icon', {
  bind: function(el, binding) {
    let icon = null
    if (binding.value && binding.value in icons) {
      icon = icons[binding.value]
      el.innerHTML = getIconHtml(icon)
    }
  }
})

new Vue({
  router,
  store,

  components: {
    LoadingOverlay
  },

  i18n,
  render: h => h(App)
}).$mount('#app')
